import { useEffect, useState } from "react";
import { cn } from "@/core/helpers/cn";

type Props = {
  isShow: boolean;
  setIsShow: (value: boolean) => void;
  title: string;
  subTitle: string;
  timer?: number;
  iconClassName?: string;
  titleClassName?: string;
  subTitleClassName?: string;
};

export default function BusinessCardApply({
  isShow,
  setIsShow,
  title,
  subTitle,
  timer,
  iconClassName,
  titleClassName,
  subTitleClassName,
}: Props) {
  const [count, setCount] = useState(5);

  useEffect(() => {
    if (!isShow || !timer) return () => {};
    setCount(5);
    const timerId = setInterval(() => {
      setCount((prevCount) => {
        if (prevCount <= 1) {
          clearInterval(timerId);
          return 0;
        }
        return prevCount - 1;
      });
    }, 1000);

    return () => clearInterval(timerId);
  }, [isShow, timer]);

  useEffect(() => {
    if (timer && count === 0) {
      setIsShow(false);
    }
  }, [count, setIsShow, timer]);

  if (!isShow) return null;

  return (
    <div
      className="absolute z-1 top-0 left-0 flex flex-col justify-center items-center size-full"
      style={{
        backdropFilter: "blur(5px)",
        background:
          "linear-gradient(180deg, rgba(0, 127, 219, 0.00) 0%, rgba(0, 127, 219, 0.30) 100%), rgba(24, 24, 24, 0.96)",
      }}
    >
      <img
        src="/svg/business/complete.svg"
        alt="ico"
        className={cn("mb-5 size-12", iconClassName)}
      />
      <p className={cn("mb-2.5 text-18 font-bold leading-none", titleClassName)}>{title}</p>
      <p
        className={cn(
          "text-15 font-medium text-center leading-none !text-accent-solid",
          timer && "mb-5",
          subTitleClassName,
        )}
      >
        {subTitle}
      </p>
      {timer && <p className="text-[2rem] font-bold text-accent-solid leading-none">{count}</p>}
    </div>
  );
}
